export enum ClubStatus{
    OPEN = 1,
    ARCHIVED = 9,
    CLOSED = 11,
    DRAFT = 8,
    DELETE = 0,
}